import Swiper from '@src/components/swiper';
import { ScreensInt } from '@tailwindConfig/screens.config';


export const defaultVariationSwiper = () => {
  new Swiper('.swiper-testimonials', {
    // Default parameters
    slidesPerView: 1,
    watchOverflow: true,
    breakpoints: {
      1: { // when window width is >= 1px
        spaceBetween: 80
      },
      [ScreensInt.md]: { // when window width is >= md px
        spaceBetween: 800
      }
    },
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination-testimonials',
      clickable: true
    }
  });
};
